// Pillars keys
const SLEEP = 'Sleep'
const NUTRITION = 'Nutrition'
const EXERCISE = 'Exercise'
const COMMUNITY = 'Community'
const STRESS = 'StressManagement'
const OCCUPATION = 'MeaningfulActivity'

const POSITIVE = 'PositiveEmployer'
const SATISFACTION = 'LifeSatisfaction'

const PILLARS = { SLEEP, EXERCISE, NUTRITION, COMMUNITY, OCCUPATION, STRESS }
const WELLBEINGATWORK = { POSITIVE, SATISFACTION }

export const RESOURCEdb = { PILLARS, WELLBEINGATWORK }

export const FILTER_BY_PILLARS_PREFIXES = {
    [COMMUNITY]: 'C_',
    [EXERCISE]: 'E_',
    [OCCUPATION]: 'MA_',
    [NUTRITION]: 'N_',
    [SLEEP]: 'S_',
    [STRESS]: 'SM_',
}
export const GOALTAGS_PREFIXES = {
    [COMMUNITY]: 'CO_',
    [EXERCISE]: 'EX_',
    [OCCUPATION]: 'MA_',
    [NUTRITION]: 'N_',
    [SLEEP]: 'S_',
    [STRESS]: 'SM_',
}

export const PILLARS_TEXT = {
    [SLEEP]: 'Sleep',
    [NUTRITION]: 'Nutrition',
    [EXERCISE]: 'Exercise',
    [COMMUNITY]: 'Community',
    [STRESS]: 'Stress Management',
    [OCCUPATION]: 'Meaningful Activity',
    [POSITIVE]: 'Wellbeing at Work', // 'Positive Employer' or 'Wellbeing at Work'
    [SATISFACTION]: 'Life Satisfaction',
}

// Used M/W for Wellbeing page data
export const PILLARS_KEYS_BY_CAMEL_CASE_PILLARS = {
    community: COMMUNITY,
    exercise: EXERCISE,
    meaningfulActivity: OCCUPATION,
    nutrition: NUTRITION,
    sleep: SLEEP,
    stressManagement: STRESS,
}

export const PILLAR_COLOURS = {
    [SLEEP]: {
        dark: 'var(--color-sleep-dark)',
        medium: 'var(--color-sleep)',
        light: 'var(--color-sleep-light)',
    },
    [EXERCISE]: {
        dark: 'var(--color-exercise-dark)',
        medium: 'var(--color-exercise)',
        light: 'var(--color-exercise-light)',
    },
    [COMMUNITY]: {
        dark: 'var(--color-community-dark)',
        medium: 'var(--color-community)',
        light: 'var(--color-community-light)',
    },
    [OCCUPATION]: {
        dark: 'var(--color-meaningful-dark)',
        medium: 'var(--color-meaningful)',
        light: 'var(--color-meaningful-light)',
    },
    [NUTRITION]: {
        dark: 'var(--color-nutrition-dark)',
        medium: 'var(--color-nutrition)',
        light: 'var(--color-nutrition-light)',
    },
    [STRESS]: {
        dark: 'var(--color-stress-dark)',
        medium: 'var(--color-stress)',
        light: 'var(--color-stress-light)',
    },
    [SATISFACTION]: {
        dark: 'var(--grey-dark)',
        medium: 'var(--grey-med)',
        light: 'var(--grey-light)',
    },
    [POSITIVE]: {
        dark: 'var(--grey-dark)',
        medium: 'var(--grey-med)',
        light: 'var(--grey-light)',
    },
    blue: {
        dark: 'var(--blue)', // default text colour
        medium: 'var(--blue-med)',
        light: 'var(--blue-light)',
    },
    grey: {
        dark: 'var(--grey-dark)',
        medium: 'var(--grey-med)',
        light: 'var(--grey-light)',
    },
    beige: 'var(--beige)',
    white: 'var(--white)',
}

export const PILLAR_SCORES_ORDER = [
    SLEEP,
    EXERCISE,
    NUTRITION,
    COMMUNITY,
    OCCUPATION,
    STRESS,
    SATISFACTION,
    POSITIVE,
]
